import React, { Component } from 'react';
import { Route, NavLink, Switch } from 'react-router-dom';
import {AuthManager} from "../../components/Authentication/AuthManager";

import {getDisciplines, getCurrentDisciplines, getThisMonthDisciplines, getPreviousMonthDisciplines} from "../../api/public/disciplines.js";
import {getAthletes} from "../../api/internal/athletes.js";
import {getProgress} from "../../api/internal/progress.js";
import {getRanking} from "../../api/internal/ranking.js";
import {getCategoriesResults} from "../../api/internal/categories.js";

import './Dashboard/Dashboard.css';
import logo from 'static/img/logo-white.svg';

import Dashboard from './Dashboard/Dashboard';
import Participants from './Participants/Participants';
import NewActivity from './NewActivity/NewActivity';
import EditActivity from './EditActivity/EditActivity';
import Rules from './Rules/Rules';
import Beneficiaries from './Beneficiaries/Beneficiaries';
import AthletesList from './AthletesList/AthletesList';
import AthleteProfile from './AthleteProfile/AthleteProfile';
import UserProfile from './UserProfile/UserProfile';

import IconNewActivity from 'static/img/IconNewActivity';
import IconParticipants from 'static/img/IconParticipants';
import IconDashboard from 'static/img/IconDashboard';
import IconBeneficiaries from 'static/img/IconBeneficiaries';
import IconRules from 'static/img/IconRules';

class AppDashboard extends Component {

  setRankingCategory = (category) =>{
    let categoriesList = [];
    switch(this.state.period){
      case 'current':
        categoriesList = this.state.thisMonthCategories;
        break;
      case 'previous':
        categoriesList = this.state.previousMonthCategories;
        break;
      case 'total':
        categoriesList = this.state.categories;
        break;
      default:
        categoriesList = this.state.categories;
        break;
    }

    if(categoriesList.some(cat => cat.name === category)){
      this.setState({
        rankingCategory: category
      });
    } else {
      this.setState({
        rankingCategory: 'All'
      });
    }
  }

  setRankingInputFilter = (input) =>{
    this.setState({rankingInputFilter: input})
  }

  setPeriod = (period) => {
    if(period === this.state.period){return false;}
    this.setState({
      period: period,
      rankingLoading: true
    });
  }

  getPeriodParams = () => {
    switch(this.state.period){
      case 'current':
        const today = new Date();
        return `?year=${today.getFullYear()}&month=${today.getMonth()+1}`;
      case 'previous':
        const previousMonthDate = new Date();
        previousMonthDate.setDate(0);
        return `?year=${previousMonthDate.getFullYear()}&month=${previousMonthDate.getMonth()+1}`;
      case 'total':
      default:
        return '';
    }
  }

  /* State methods */
  setDisciplinesState(){
    getDisciplines()
      .then(result => {
        this.setState({categories: result});
      })
      .catch(error => {
        this.setState({categories: []});
        console.log('getDisciplines() ERROR', error);
      });
    getCurrentDisciplines()
      .then(result => {
        this.setState({currentCategories: result});
      })
      .catch(error => {
        this.setState({currentCategories: []});
        console.log('getCurrentDisciplines() ERROR', error);
      });
    getThisMonthDisciplines()
      .then(result => {
        this.setState({thisMonthCategories: result});
      })
      .catch(error => {
        this.setState({thisMonthCategories: []});
        console.log('getThisMonthDisciplines() ERROR', error);
      });
    getPreviousMonthDisciplines()
      .then(result => {
        this.setState({previousMonthCategories: result});
      })
      .catch(error => {
        this.setState({previousMonthCategories: []});
        console.log('getPreviousMonthDisciplines() ERROR', error);
      });
  }

  setAthletesState(){
    getAthletes()
      .then(result => {
        this.setState({athletes: result });
      })
      .catch(error => {
        this.setState({athletes: [] });
        console.error('setAthletesState() ERROR', error);
      });
  }

  setProgressState = () => {
    getProgress(this.getPeriodParams())
      .then(
        (result) => {
          this.setState({
            pointsAndMoney: {
              'points': result.totalPoints,
              'money': result.totalMoney
            },
            progress: {
              'currentPoints':Math.floor(result.currentPoints),
              'pointsThreshold':Math.floor(result.pointsThreshold),
              'payment': result.payment
            },
            timeAndDistance:{
              'totalTime': Math.floor(result.totalDuration),
              'totalDistance': Math.floor(result.totalDistance),
            }
          });
        },
        (error) => {console.error('setProgressState() ERROR:', error); }
      );
  }

  setRankingState = () => {
    const categoryParam = (this.state.rankingCategory === 'All' ? '' : '/'+this.state.rankingCategory);
    getRanking(categoryParam+this.getPeriodParams())
      .then(result => {
          this.setState({
            ranking: result,
            rankingLoading: false
          });
        },
        (error) => {this.setState({ranking: []}); console.error('setRankingState() ERROR', error); }
      );
  }

  setCategoriesResultsState = () => {
    getCategoriesResults(this.getPeriodParams())
      .then(
        (result) => {
          this.setState({categoriesResults : result});
         },
        (error) => {
          this.setState({categoriesResults : []});
          console.error('setCategoriesResultsState() ERROR', error); }
      );
  }

  handleActivityAdded(){
    this.setRankingState();
    this.setProgressState();
    this.setCategoriesResultsState();
  }

  constructor(props) {
    super(props);
    this.state = {
      period: 'current', // current | previous | total
      categories: [],
      currentCategories: [],
      thisMonthCategories: [],
      previousMonthCategories: [],
      athletes: [],
      ranking: [],
      categoriesResults: [],
      pointsAndMoney:{'points': 0, 'money': 0},
      timeAndDistance:{'totalTime': 0, 'totalDistance': 0},
      progress: {'currentPoints':0, 'pointsThreshold':1, 'payment': 0},
      rankingLoading: true,
      rankingCategory: 'All',
      rankingInputFilter: '',
      user: null
    }
    this._authManager = new AuthManager();
  }

  render() {
    return (
      <div className="Dashboard">
        <aside className="Dashboard-side">
          <NavLink to="/dashboard" exact={true} >
            <img className="Dashboard-logo" src={logo} alt="Burn for Money" />
          </NavLink>
          <ul className="Navigation">
            <li className="NavigationItem NavigationItem__dashboard">
              <NavLink to="/dashboard" className="NavigationItem-link" exact={true}>
                <IconDashboard className="NavigationItem-icon" />
                <span className="NavigationItem-text">Dashboard</span>
              </NavLink>
            </li>
            <li className="NavigationItem NavigationItem__participants">
              <NavLink to="/dashboard/participants" className="NavigationItem-link">
                <IconParticipants className="NavigationItem-icon" />
                <span className="NavigationItem-text">Participants</span>
              </NavLink>
            </li>
            <li className="NavigationItem NavigationItem__beneficiaries">
              <NavLink to="/dashboard/beneficiaries" className="NavigationItem-link">
                <IconBeneficiaries className="NavigationItem-icon" />
                <span className="NavigationItem-text">Beneficiaries</span>
              </NavLink>
            </li>
            <li className="NavigationItem NavigationItem__rules">
              <NavLink to="/dashboard/rules" className="NavigationItem-link">
                <IconRules className="NavigationItem-icon" />
                <span className="NavigationItem-text">Rules</span>
              </NavLink>
            </li>
            <li className="NavigationItem NavigationItem__addActivity">
              <NavLink to="/dashboard/new-activity" className="Button NavigationItem-link">
                <IconNewActivity className="NavigationItem-icon" />
                <span className="NavigationItem-text">Add activity</span>
              </NavLink>
            </li>
          </ul>
        </aside>

        <section className="Dashboard-main">
          <Switch>
            <Route exact path="/dashboard" render={(props) => (
              <Dashboard {...props}
                user={this.state.user}
                ranking={this.state.ranking.slice(0, 10)}
                rankingLoading={this.state.rankingLoading}
                rankingCategory={this.state.rankingCategory}
                setRankingCategory={this.setRankingCategory}
                categories={this.state.categories}
                thisMonthCategories={this.state.thisMonthCategories}
                previousMonthCategories={this.state.previousMonthCategories}
                categoriesResults={this.state.categoriesResults}
                timeAndDistance={this.state.timeAndDistance}
                pointsAndMoney={this.state.pointsAndMoney}
                progress={this.state.progress}
                period={this.state.period}
                setPeriod={this.setPeriod}
              />
            )} />
            <Route exact path="/dashboard/participants" render={(props) => (
              <Participants {...props}
                user={this.state.user}
                ranking={this.state.ranking}
                rankingLoading={this.state.rankingLoading}
                rankingCategory={this.state.rankingCategory}
                setRankingCategory={this.setRankingCategory}
                rankingInputFilter={this.state.rankingInputFilter}
                setRankingInputFilter={this.setRankingInputFilter}
                categories={this.state.categories}
                thisMonthCategories={this.state.thisMonthCategories}
                previousMonthCategories={this.state.previousMonthCategories}
                period={this.state.period}
                setPeriod={this.setPeriod}
            />
            )} />
            <Route exact path="/dashboard/new-activity" render={(props) => (
              <NewActivity {...props}
                user={this.state.user}
                categories={this.state.currentCategories}
                onActivityAdded={()=>this.handleActivityAdded()}
              />
            )} />
            <Route exact path="/dashboard/edit-activity" render={(props) => (
              <EditActivity {...props}
                user={this.state.user}
                categories={this.state.categories}
                onActivityAdded={()=>this.handleActivityAdded()}
              />
            )} />
            <Route path="/dashboard/athletes-list" render={(props) => (
              <AthletesList {...props}
                user={this.state.user}
                athletes={this.state.athletes}
              />
            )} />

            <Route path="/dashboard/beneficiaries" render={(props) => (
              <Beneficiaries {...props}
                user={this.state.user}
              />
            )} />
            <Route path="/dashboard/rules" render={(props) => (
              <Rules {...props}
                user={this.state.user}
                categories={this.state.currentCategories}
              />
            )} />

            <Route path="/dashboard/user" render={(props) => (
              <UserProfile {...props}
                user={this.state.user}
                categories={this.state.categories}
                timeAndDistance={this.state.timeAndDistance}
                pointsAndMoney={this.state.pointsAndMoney}
              />
            )} />
            <Route path="/dashboard/athlete/:athleteId" component={AthleteProfile} />
          </Switch>
        </section>
      </div>
    )
  }

  componentDidMount(){
    this.setDisciplinesState();
    this.setAthletesState();
    this.setRankingState();
    this.setProgressState();
    this.setCategoriesResultsState();
    this._authManager.getUser().then(user => {
      if(user)
        this.setState({"user": user});
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.rankingCategory !== prevState.rankingCategory) {
      this.setState({rankingLoading: true });
      this.setRankingState();
    }

    if(this.state.period !== prevState.period){
      this.setRankingState();
      this.setProgressState();
      this.setCategoriesResultsState();
      this.setRankingCategory(this.state.rankingCategory);
    }
  }
}

export default AppDashboard;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/BfmPanel.js